"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingCostSummary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const advertising_module_scss_1 = __importDefault(require("../advertising.module.scss"));
const formatEuro = (value) => `${value.toLocaleString('es-ES')} €`;
const AdvertisingCostSummary = ({ summary, loading, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: advertising_module_scss_1.default.costSummary, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: advertising_module_scss_1.default.costSummaryLabel, children: t('advertising.machines.costSummary.label') }), (0, jsx_runtime_1.jsx)("span", { className: advertising_module_scss_1.default.costSummaryValue, children: loading ? '—' : formatEuro(summary.estimatedCost) })] }), (0, jsx_runtime_1.jsx)("div", { className: advertising_module_scss_1.default.costSummaryHint, children: loading
                    ? '—'
                    : t('advertising.machines.costSummary.detail', {
                        count: summary.enabledMachines,
                        cost: summary.costPerMachine,
                    }) })] }));
};
exports.AdvertisingCostSummary = AdvertisingCostSummary;
